import React, { useContext } from 'react';
import { Icon } from '@iconify/react';
import { TextsContext } from '../../context/textsContext';
import { TitleH2Component } from '../TitleH2Component';
import { ParagraphComponent } from '../ParagraphComponent';
import style from '../../scss/saveFavoritePlan.module.scss';

/**
 * Estado "error" del diálogo de guardar plan favorito: el POST/PATCH falló.
 * El diálogo ofrece Retry / Cancel desde este estado.
 *
 * @param {boolean} isEdit  cambia el texto a "actualizar" en modo edición
 */
const SaveErrorState = ({ isEdit = false }) => {
    const { texts } = useContext(TextsContext);

    return (
        <>
            <Icon icon="mdi:alert-circle-outline" width={40} height={40} style={{ color: '#F12B24' }} className={style.icon} />
            <TitleH2Component styleGroup={`raleway color_primary ${style.title}`}>
                {texts?.favorite_plan_save_error_title ?? 'Something went wrong'}
            </TitleH2Component>
            <ParagraphComponent styleGroup={`Poppins ${style.text}`}>
                {isEdit
                    ? (texts?.favorite_plan_update_error_text ?? 'We couldn’t update your plan. Please try again.')
                    : (texts?.favorite_plan_save_error_text ?? 'We couldn’t save your plan. Please try again.')}
            </ParagraphComponent>
        </>
    );
};

export default SaveErrorState;
